// Auth screen — login/register tab toggle.
// Markup: see app/views/devise/sessions/new.html.erb (.auth-screen).

const initConnection = () => {
  const panel = document.getElementById("container");
  if (!panel || !panel.classList.contains("auth-screen__panel")) return;

  const tabs = panel.querySelectorAll(".auth-screen__tab");
  const forms = panel.querySelectorAll(".auth-screen__form");
  if (!tabs.length || !forms.length) return;

  const showForm = (target) => {
    tabs.forEach((tab) => {
      const isActive = tab.id === target;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", String(isActive));
    });
    forms.forEach((form) => {
      form.classList.toggle("is-hidden", form.dataset.form !== target);
    });
    panel.classList.toggle("active", target === "register");
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => showForm(tab.id));
  });

  // Toggle password visibility for any [data-target] reveal button.
  panel.querySelectorAll(".toggle-password").forEach((btn) => {
    btn.addEventListener("click", () => {
      const targetId = btn.getAttribute("data-target");
      if (!targetId) return;
      const input = document.getElementById(targetId);
      if (!input) return;
      const isHidden = input.type === "password";
      input.type = isHidden ? "text" : "password";
      const icon = btn.querySelector("i");
      if (icon) icon.classList.toggle("fa-eye-slash", isHidden);
    });
  });

  // Honour ?action=register query for direct deep links.
  const params = new URLSearchParams(window.location.search);
  if (params.get("action") === "register") showForm("register");
};

export { initConnection };
